import {
  GetNotaryBidResponse,
} from '~/types/backend';
import { TListParams } from '~/types/global';
import { GetMyNotaryBidsResponse } from '~/types/backend';
import {
  GET_NOTARY_BID_LIST,
  GET_NOTARY_BID_LIST_ERR,
  GET_NOTARY_BID_LIST_OK,
  SET_NOTARY_BID_FILTER_TOGGLE,
  DO_NOTARY_BID_LIST_CLEANUP,

  GET_NOTARY_BID,
  GET_NOTARY_BID_OK,
  GET_NOTARY_BID_ERR,
} from "./actionTypes";

export const getNotaryBidList = (params: TListParams) => ({
  type: GET_NOTARY_BID_LIST,
  payload: { params },
});

export const getNotaryBidListOk = (response: GetMyNotaryBidsResponse) => ({
  type: GET_NOTARY_BID_LIST_OK,
  payload: { response },
});

export const getNotaryBidListErr = (error: Error) => ({
  type: GET_NOTARY_BID_LIST_ERR,
  payload: { error },
});

export const setNotaryBidFilterToggle = (status: number) => ({
  type: SET_NOTARY_BID_FILTER_TOGGLE,
  payload: { status },
});

export const doNotaryBidListCleanup = () => ({
  type: DO_NOTARY_BID_LIST_CLEANUP,
});

/********** SINGLE **********/

export const getNotaryBid = (id: number) => ({
  type: GET_NOTARY_BID,
  payload: { id },
});

export const getNotaryBidOk = (response: GetNotaryBidResponse) => ({
  type: GET_NOTARY_BID_OK,
  payload: { response },
});

export const getNotaryBidErr = (error: Error) => ({
  type: GET_NOTARY_BID_ERR,
  payload: { error },
});